import { Space, Typography } from 'antd';
import { AdminOperatorsTable } from '../settings/AdminOperatorsTable';

/**
 * Dedicated top-level page for managing admin operators. Mirrors the
 * Settings → Admin accounts block but lives at /admins so super_admins
 * can jump there from the sidebar without scrolling Settings.
 *
 * The table component is shared with Settings, so any UX or column
 * change automatically applies to both surfaces.
 */
export function AdminsPage() {
  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Typography.Title level={3} style={{ color: 'white', margin: 0 }}>
        Admin team
      </Typography.Title>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 0 }}>
        Create, edit, reset passwords, and disable admin operators. Super-admin only.
        Every action is captured in the audit log with the actor and before/after diff.
      </Typography.Paragraph>
      <AdminOperatorsTable />
    </Space>
  );
}
